import React, { useEffect, useState } from "react";
import "../termsAndConditions/termsAndConditions.css";
import RichTextEditor from "react-rte";
import { toast } from "react-toastify";

const TermsAndConditions = ({ onChange }) => {
  const [value, setValue] = useState(
    RichTextEditor.createValueFromString(``, "html")
  );

  const handleChange = (value) => {
    setValue(value);
    if (onChange) {
      // Send the changes up to the parent component as an HTML string.
      // This is here to demonstrate using `.toString()` but in a real app it
      // would be better to avoid generating a string on each change.
      onChange(value.toString("html"));
    }
  };

  const createTermsAndCondition = async () => {
    try {
      const data = {
        content: value.toString("html"),
        type: "termsAndCondition",
      };

      const response = null;

      if (response) {
        toast.success("Update successfully !");
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const loadContents = async () => {
    try {
      const response = null;

      const initialValue = RichTextEditor.createValueFromString(
        `${response.termsAndCondition} `,
        "html"
      );

      setValue(initialValue);
    } catch (error) {
      toast.error(error);
    }
  };

  useEffect(() => {
    loadContents();
  }, []);

  return (
    <div className="container">
      <div className="overview d-flex align-items-center justify-content-between">
        <div className="title">
          <ion-icon name="reader-outline"></ion-icon>
          <span className="text">Terms & Conditions</span>
        </div>
        <button
          id="terms-and-condition"
          className="btn-header d-flex align-items-center gap-1"
          onClick={createTermsAndCondition}
        >
          {/* <ion-icon name="add-outline"></ion-icon> */}
          Update
        </button>
      </div>

      <RichTextEditor
        value={value}
        onChange={handleChange}
        className="terms-conditions"
      />
    </div>
  );
};

export default TermsAndConditions;
